type WebpackPublicPathGlobal = typeof globalThis & {
  __webpack_public_path__?: string;
};

function getWebpackPublicPath(): string {
  const path = (globalThis as WebpackPublicPathGlobal).__webpack_public_path__;
  return typeof path === 'string' && path.length > 0 ? path : '/';
}

/**
 * Resolve a rspack-emitted media path against the deploy-time CDN base
 * (__webpack_public_path__, set from RUNTIME_CONFIG.ASSET_SERVER in runtime-config.js).
 * Accepts build-time placeholders and legacy absolute CDN URLs so sessionStorage
 * entries from older deploys still resolve to the current asset server.
 */
export function resolveCdnAssetUrl(assetUrl: string): string {
  const trimmed = assetUrl.trim();
  if (trimmed.startsWith('data:')) {
    return trimmed;
  }

  let relative = trimmed;
  const baked = trimmed.match(/^(?:https?:\/\/[^/]+|__ASSET_SERVER__)\/(media\/[^?#]+)/i);
  if (baked) {
    relative = baked[1];
  } else if (trimmed.startsWith('/media/')) {
    relative = trimmed.slice(1);
  }

  const publicPath = getWebpackPublicPath();
  const normalized = relative.replace(/^\/+/, '');
  return publicPath.endsWith('/') ? publicPath + normalized : `${publicPath}/${normalized}`;
}
